export default __webpack_public_path__ + "static/media/190629_192557_DSCN2975.5a4fad8f.JPG";